
import { Component, Vue } from 'vue-property-decorator'
import HeadLable from '@/components/HeadLable/index.vue'
import { getEmployeeList, enableOrDisableEmployee, deleteEmployee } from '@/api/employee'
import { UserModule } from '@/store/modules/user'
import InputAutoComplete from '@/components/InputAutoComplete/index.vue'
import Empty from '@/components/Empty/index.vue'

@Component({
  name: 'Employee',
  components: {
    HeadLable,
    InputAutoComplete,
    Empty,
  },
})
export default class extends Vue {
  private input: any = ''
  private counts: number = 0
  private page: number = 1
  private pageSize: number = 10
  private tableData = []
  private id = ''
  private status = ''
  private isSearch: boolean = false

  created() {
    this.init()
  }

  initProp(val) {
    this.input = val
    this.initFun()
  }

  initFun() {
    this.page = 1
    this.init()
  }

  get userName() {
    return UserModule.username
  }

  /** 系统管理员账号不可改/禁/删 */
  private isProtectedAdmin(row: any) {
    return row && String(row.username || '').toLowerCase() === 'admin'
  }

  /** 当前登录账号不可禁用/删除自己 */
  private isSelf(row: any) {
    if (!row) return false
    const info: any = UserModule.userInfo || {}
    if (row.id != null && info.id != null && String(row.id) === String(info.id)) {
      return true
    }
    const mine = String(UserModule.username || info.userName || info.username || '').trim().toLowerCase()
    const target = String(row.username || '').trim().toLowerCase()
    return !!(mine && target && mine === target)
  }

  private async init(isSearch?: boolean) {
    this.isSearch = isSearch
    const params = {
      page: this.page,
      pageSize: this.pageSize,
      name: this.input ? this.input : undefined,
    }
    await getEmployeeList(params)
      .then((res: any) => {
        if (String(res.data.code) === '1') {
          this.tableData = res.data && res.data.data && res.data.data.records
          this.counts = res.data.data.total
        }
      })
      .catch((err) => {
        this.$message.error('请求出错了：' + err.message)
      })
  }

  // 添加
  private addEmployeeHandle(st: string, username: string) {
    if (st === 'add') {
      this.$router.push({ path: '/employee/add' })
    } else {
      if (username && String(username).toLowerCase() === 'admin') {
        return
      }
      this.$router.push({ path: '/employee/add', query: { id: st } })
    }
  }

  //状态修改
  private statusHandle(row: any) {
    if (this.isProtectedAdmin(row) || this.isSelf(row)) {
      if (this.isSelf(row)) {
        this.$message.warning('不能禁用当前登录账号')
      }
      return
    }
    this.id = row.id
    this.status = row.status
    this.$confirm('确认调整该账号的状态?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      enableOrDisableEmployee({ id: this.id, status: !this.status ? 1 : 0 })
        .then((res) => {
          if (String(res.status) === '200') {
            this.$message.success('账号状态更改成功！')
            this.init()
          }
        })
        .catch((err) => {
          this.$message.error('请求出错了：' + err.message)
        })
    })
  }

  private deleteHandle(row: any) {
    if (this.isSelf(row)) {
      this.$message.warning('不能删除当前登录账号')
      return
    }
    if (this.isProtectedAdmin(row)) {
      this.$message.warning('管理员账号不能删除')
      return
    }
    this.$confirm(`确认删除人员「${row.name || row.username}」？删除后不可恢复`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(async () => {
      try {
        const res: any = await deleteEmployee(row.id)
        if (String(res.data.code) === '1') {
          this.$message.success('删除成功')
          this.init()
        } else {
          this.$message.error(res.data.msg || '删除失败')
        }
      } catch (err) {
        this.$message.error('请求出错了：' + (err as Error).message)
      }
    }).catch(() => {})
  }

  private handleSizeChange(val: any) {
    this.pageSize = val
    this.init()
  }

  private handleCurrentChange(val: any) {
    this.page = val
    this.init()
  }
}
